import React, { useState, useEffect } from "react";
import Header from "../dashboard/header";
import { Link } from "react-router-dom";
import { Table, Modal, Button, Carousel } from "react-bootstrap";
import { useCart } from "./CartContext";
import {
  FaPlus,
  FaEdit,
  FaTrash,
  FaSortAmountUp,
  FaSortAmountDown,
  FaTools,
  FaShoppingBag,
  FaShoppingCart,
  FaCreditCard,
  FaTrashAlt,
  FaMinus,
  FaEye,
} from "react-icons/fa";
import Navbar from "../dashboard/navbar";
import { useLocation, useNavigate } from "react-router-dom";
import Sidebar from "../dashboard/sidebar";
import useAuth from "../dashboard/useAuth";
import HeroCarousel from "./carousel";
import Footer from "../dashboard/footer";
import FedaPayButton from "./FedaPayButton";
import axios from "axios";
import { useMediaQuery } from "react-responsive";

const Accueil = ({ titre }) => {
  const [produits, setProduits] = useState([]);
  const [userInfo, setUserInfo] = useState([]);
  const [expandedDescriptions, setExpandedDescriptions] = useState({});
  const [selectedProduit, setSelectedProduit] = useState(null);
  const [quantity, setQuantity] = useState(1);
  const [initialLoad, setInitialLoad] = useState(true);
  const [filtreTypePaiement, setFiltreTypePaiement] = useState("tous"); // 'tous', 'unique', 'abonnement'
  const [sortConfig, setSortConfig] = useState({
    key: "id",
    direction: "ascending",
  });
  const [searchTerm, setSearchTerm] = useState("");
  const [alert, setAlert] = useState({ message: "", type: "" });
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(16);
  const location = useLocation();
  const [descriptionOverflows, setDescriptionOverflows] = useState({});
  const [categories, setCategories] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState("all");
  const isMobile = useMediaQuery({ maxWidth: 767 });
  // const { cartItems, addToCart, removeFromCart, updateQuantity, clearCart } =
  //   useCart();

  const user_id = localStorage.getItem("IDDDD");
  const navigate = useNavigate();

  // Utilisation de useEffect pour mettre à jour le titre de la page
  useEffect(() => {
    if (user_id) {
      document.title = "PayMe | Produit"; // Définit le titre de la page
    }
  }, [user_id]);

  const {
    cartItems,
    addToCart,
    removeFromCart,
    updateQuantity,
    clearCart,
    subTotal,
    deliveryCost,
  } = useCart();
  // Fonctions de gestion du panier

  const fetchProduits = async () => {
    try {
      const response = await fetch(
        process.env.REACT_APP_HOTE + "/liste-produit/"
      );
      if (response.ok) {
        const data = await response.json();
        setProduits(data);
      } else {
        console.error("Erreur lors de la récupération des produits");
      }
    } catch (error) {
      console.error("Erreur réseau:", error);
    }
  };
  useEffect(() => {
    fetchProduits();
  }, []);

  useEffect(() => {
    const fetchCategories = async () => {
      try {
        const response = await fetch(
          process.env.REACT_APP_HOTE + "/liste-categorie/"
        );
        if (response.ok) {
          const data = await response.json();
          // Transformez les données si nécessaire
          const formattedCategories = data.map((cat) => ({
            id: cat.id,
            nom: cat.nom,
            // Ajoutez d'autres propriétés si nécessaire
          }));
          setCategories([{ id: "all", nom: "Tous" }, ...formattedCategories]);
        }
      } catch (error) {
        console.error("Erreur réseau:", error);
      }
    };
    fetchCategories();
  }, []);

  const fetchUserInfo = async () => {
    try {
      const user_id = localStorage.getItem("IDDDD");
      const url = `${process.env.REACT_APP_HOTE}/recup-info-profil/${user_id}`;
      console.log("Fetching user info from:", url);

      const response = await fetch(url);
      const data = await response.json();
      console.log("User data received:", data);

      if (response.ok) {
        setUserInfo(data);
        localStorage.setItem("userData", JSON.stringify(data));
      } else {
        console.error("Error response:", data);
      }
    } catch (error) {
      console.error("Network error:", error);
    }
  };
  useEffect(() => {
    fetchUserInfo();
  }, []);

  const showAlert = (message, type = "success") => {
    setAlert({ message, type });
    setTimeout(() => {
      setAlert({ message: "", type: "" });
      fetchProduits();
    }, 3000);
  };

  const handleRowClick = (produit) => {
    setSelectedProduit(produit);
  };

  const checkDescriptionOverflow = (produits) => {
    produits.forEach((produit) => {
      const element = document.getElementById(`description-${produit.id}`);
      if (element) {
        setDescriptionOverflows((prev) => ({
          ...prev,
          [produit.id]: element.scrollHeight > element.clientHeight,
        }));
      }
    });
  };

  useEffect(() => {
    checkDescriptionOverflow(produits);
  }, [produits]);

  const handleShowDeleteModal = () => {
    setShowDeleteModal(true);
  };

  const handleCloseDeleteModal = () => {
    setShowDeleteModal(false);
  };

  // Utiliser useEffect pour récupérer et afficher le message après redirection
  useEffect(() => {
    const successMessage = localStorage.getItem("successMessage");
    if (successMessage) {
      // Afficher le message (par exemple via une alerte ou un composant de notification)
      showAlert(successMessage);

      // Supprimer le message du localStorage après l'affichage
      localStorage.removeItem("successMessage");
    }
  }, []);

  // Redirection si pas de produits et utilisateur non connecté
  // useEffect(() => {
  //   if (initialLoad) {
  //     if (produits.length === 0) {
  //       // Stocker la page actuelle pour redirection après connexion
  //       localStorage.setItem('redirectAfterLogin', window.location.pathname);
  //       navigate('/');
  //     }
  //     setInitialLoad(false);
  //   }
  // }, [produits, initialLoad, navigate]);

  const filteredProduits = produits.filter((produit) => {
    // Filtre par catégorie
    const filtreCategorie =
      selectedCategory === "all" ||
      (produit.categorie && produit.categorie.id == selectedCategory);

    // Filtre par type de paiement
    const filtrePaiement =
      filtreTypePaiement === "tous" ||
      produit.type_paiement === filtreTypePaiement;

    // Filtre par recherche (nom du produit OU nom de la catégorie)
    const searchTermLower = searchTerm.toLowerCase();
    const filtreRecherche =
      produit.nom.toLowerCase().includes(searchTermLower) ||
      (produit.categorie && produit.categorie.nom.toLowerCase().includes(searchTermLower));

    return filtreCategorie && filtrePaiement && filtreRecherche;
  });

  // Ajoutez cette partie juste après filteredProduits
  const sortedProduits = [...filteredProduits].sort((a, b) => {
    if (sortConfig.key === 'prix' || sortConfig.key === 'prix_mensuel' || sortConfig.key === 'prix_annuel') {
      const valueA = a[sortConfig.key] || 0;
      const valueB = b[sortConfig.key] || 0;
      return sortConfig.direction === 'ascending' ? valueA - valueB : valueB - valueA;
    } else {
      // Pour le tri alphabétique sur les autres clés
      const valueA = a[sortConfig.key]?.toString().toLowerCase() || '';
      const valueB = b[sortConfig.key]?.toString().toLowerCase() || '';
      return sortConfig.direction === 'ascending'
        ? valueA.localeCompare(valueB)
        : valueB.localeCompare(valueA);
    }
  });

  // Maintenant vous pouvez utiliser sortedProduits
  const indexOfLastProduct = currentPage * itemsPerPage;
  const indexOfFirstProduct = indexOfLastProduct - itemsPerPage;
  const currentProducts = sortedProduits.slice(
    indexOfFirstProduct,
    indexOfLastProduct
  );
  const totalPages = Math.ceil(sortedProduits.length / itemsPerPage);
  const totalItems = produits.length;

  const handleSort = (key) => {
    let direction = "ascending";
    if (sortConfig.key === key && sortConfig.direction === "ascending") {
      direction = "descending";
    }
    setSortConfig({ key, direction });
  };

  const handleToggleDescription = (id) => {
    setExpandedDescriptions((prev) => ({
      ...prev,
      [id]: !prev[id],
    }));
  };

  const [accesGroupe, setAccesGroupe] = useState([]);
  const [groupeId, setGroupeId] = useState(null);
  const groupe = localStorage.getItem("groupe");

  const verifGroupe = async () => {
    const groupeStored = localStorage.getItem("groupe");
    const accesGroupeStored = localStorage.getItem("accesGroupe");

    if (groupeStored && accesGroupeStored) {
      setGroupeId(groupeStored);
      setAccesGroupe(JSON.parse(accesGroupeStored));
    } else {
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_HOTE}/verif-groupe/${user_id}/${groupe}`
        );
        if (response.status === 200) {
          const data = response.data;
          setGroupeId(data.groupe);

          let cleanedAccessArray = [];
          if (Array.isArray(data.acces)) {
            cleanedAccessArray = data.acces
              .map((item) =>
                item.acces
                  ? item.acces
                    .replace(/[\[\]']/g, "")
                    .trim()
                    .split(",")
                    .map((access) => access.trim())
                  : []
              )
              .flat();

            setAccesGroupe(cleanedAccessArray);
          }

          localStorage.setItem("groupe", data.groupe);
          localStorage.setItem(
            "accesGroupe",
            JSON.stringify(cleanedAccessArray)
          );
        }
      } catch (error) {
        // console.error('Erreur lors de la vérification du groupe', error);
      }
    }
  };

  useEffect(() => {
    if (user_id) {
      verifGroupe();
    }
  }, [user_id]);



  console.log(localStorage);

  //   const handleAcheterClick = (produit) => {
  //   if (!user_id) {
  //     // Stocker le produit dans localStorage pour y accéder après connexion
  //     localStorage.setItem('produitSelectionne', JSON.stringify(produit));
  //     navigate('/'); // Redirige vers la page de connexion
  //   } else {
  //     // Si l'utilisateur est connecté, navigue directement vers la page de détail
  //     navigate('/Detail-produit', { state: { produit } });
  //   }
  // };
  const handleAcheterClick = (produit) => {
    navigate('/Detail-produit', { state: { produit } });
  };



  return (
    <div id="wrapper">
      {user_id && <Sidebar user_id={user_id} titre={titre} />}
      <div id="page-wrapper" className="gray-bg">
        {user_id && <Navbar />}
        <div className=" wrapper-content  fadeInRight animated">
          <div className="row justify-content-center">
            <div className="col-lg-12">
              <div className="ibox">
                <div className="caroussel">

                  <HeroCarousel navigate={navigate} />
                 
                </div>
              </div>
            </div>
          </div>
          <div className="col-lg-12  mb-3">
            <div className="d-flex justify-content-center align-items-center mb-3">
              <input
                type="text"
                placeholder="Rechercher un produit ou une catégorie de produit..."
                className="form-control "
                style={{
                  maxWidth: "700px",
                  width: "100%",
                  height: "50px",
                  borderRadius: "18px",
                }}
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
              />
            </div>
          </div>
          {/* Liste des catégories */}
<div className="row justify-content-center mb-3">
  <div className="col-lg-12 d-flex justify-content-center mb-3" style={{ marginTop: "30px" }}>
    <h4>Toutes les catégories</h4>
  </div>

  <div className="col-12">
    <div className="d-flex justify-content-center">
      <div
        className="category-wrapper"
      >
        {categories.map((category) => (
          <button
            key={category.id}
            className={`btn btn-sm mr-1 flex-shrink-0 ${
              selectedCategory === category.id ? "btn-wine" : "btn-secondary"
            }`}
            onClick={() => setSelectedCategory(category.id)}
            style={{
              borderRadius: "20px",
              padding: "0.25rem 0.75rem",
              fontSize: "0.8rem",
              whiteSpace: "nowrap",
            }}
          >
            {category.nom}
          </button>
        ))}
      </div>
    </div>

    {isMobile && cartItems.length > 0 && (
      <div className="mt-2 text-center">
        <button
          className="btn btn-success btn-sm position-relative"
          onClick={() => navigate("/panier")}
        >
          <FaShoppingCart /> Panier
          <span className="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-danger">
            {cartItems.length}
          </span>
        </button>
      </div>
    )}
  </div>
  <style>{`
  .category-wrapper {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 8px;
}

@media (max-width: 768px) {
  .category-wrapper {
    flex-wrap: nowrap;
    overflow-x: auto;
    justify-content: flex-start;
    padding-bottom: 10px;
  }

  .category-wrapper::-webkit-scrollbar {
    display: none; /* cacher la scrollbar sur mobile */
  }
}
  `}</style>
</div>


          {/* Liste des produits */}
          <div className="ibox">
            <div
              className="ibox-content text-center"
              style={{
                marginTop: "30px",
                borderRadius: "20px",
                overflow: "hidden",
              }}
            >
              {" "}
              {/* Changement ici */}
              <div className="col-lg-12  mb-3">
                <div className="col-lg-12 d-flex justify-content-center mb-3">
                  <h4>Liste des produits</h4>
                  {/* <select
      value={filtreTypePaiement}
      onChange={(e) => setFiltreTypePaiement(e.target.value)}
      className="form-select bg-default"
      style={{
        width: "auto",
                            border: "1px black solid",
                            borderRadius: "5px",
      }}
    >
      <option value="tous">Tous les types</option>
      <option value="unique">Paiement unique</option>
      <option value="abonnement">Abonnement</option>
    </select> */}
                </div>
              </div>
              <div className="row gx-2 gy-3">
                {currentProducts.map((produit) => (
                  <div
                    key={produit.id}
                    className="col-6 col-md-4 col-lg-2-4 mb-3"
                  >
                    <div className="ibox h-100" style={{ margin: 0 }}>
                      {" "}
                      {/* Ajout de style */}
                      <div
                        className="ibox-content product-box h-100"
                        style={{ padding: "10px" }}
                      >
                        <div
                          className="product-imitation"
                          style={{
                            height: isMobile ? "120px" : "200px",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            overflow: "hidden",
                          }}
                        >
                          <img
                            src={
                              produit.photo_url ||
                              "/static/images/default-product.png"
                            }
                            alt={produit.nom}
                            style={{
                              minWidth: "100%",
                              minHeight: "100%",
                              objectFit: "cover",
                            }}
                            onError={(e) => {
                              e.target.onerror = null;
                              e.target.src =
                                "/static/images/default-product.png";
                            }}
                          />
                        </div>
                        <div className="product-desc p-2">
                          <small className="badge text-muted">
                            {produit.categorie.nom}
                          </small>
                          <a
                            href="#"
                            className="product-name text-dark"
                            style={{ fontSize: isMobile ? "0.9rem" : "1rem" }}
                          >
                            {produit.nom}
                          </a>
                          <p
                            className="text-success fw-bold"
                            style={{ fontSize: "0.8rem" }}
                          >
                            {produit.type_paiement === "abonnement"
                              ? (produit.prix_mensuel === 0
                                ? Math.floor(produit.prix_annuel).toLocaleString('fr-FR')
                                : Math.floor(produit.prix_mensuel).toLocaleString('fr-FR'))
                              : Math.floor(produit.prix).toLocaleString('fr-FR')} FCFA
                          </p>
                          <div className="m-t text-center">
                            <button
                              className="btn btn-xs btn-outline btn-wine"
                              onClick={(e) => {
                                e.stopPropagation();
                                handleAcheterClick(produit);
                              }}
                            >
                              {produit.type_paiement === "abonnement" ? "S'abonner" : "Acheter"} <FaShoppingCart />
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
                <div className="col-lg-12 mb-3">
                  {/* Pagination Controls */}
                  <div className="d-flex justify-content-between align-items-center mt-3">
                    <div
                      className="dataTables_info"
                      role="status"
                      aria-live="polite"
                    >
                      {totalItems === 0
                        ? "Aucun élément à afficher"
                        : `Élément ${currentPage === 1
                          ? 1
                          : (currentPage - 1) * itemsPerPage + 1
                        } à ${currentPage * itemsPerPage > totalItems
                          ? totalItems
                          : currentPage * itemsPerPage
                        } sur ${totalItems}`}
                    </div>
                    <div>
                      {Array.from({ length: totalPages }, (_, index) => (
                        <button
                          key={index + 1}
                          onClick={() => setCurrentPage(index + 1)}
                          className={`btn ${currentPage === index + 1
                            ? "btn-default"
                            : "btn-light"
                            } mx-1`}
                        >
                          {index + 1}
                        </button>
                      ))}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div>

          <div className="mt-3">
            {/* <div className="d-flex">
                                    <Link to={`/Ajouter-produit`} className="btn btn-success mr-2">
                                        <FaPlus /> Ajouter produit
                                    </Link>
                                </div> */}
            {alert.message && (
              <div className={`alert alert-${alert.type}`}>{alert.message}</div>
            )}
            <Modal
              show={selectedProduit !== null}
              onHide={() => setSelectedProduit(null)}
              centered
              size="lg"
            >
              {/* En-tête original conservé */}

              <Modal.Header>
                <Modal.Title>Détails du produit</Modal.Title>
              </Modal.Header>

              <Modal.Body>
                {selectedProduit && (
                  <div className="row">
                    {/* Colonne Photo */}
                    <div className="col-md-5  mb-3 mb-md-0">
                      <div
                        className=" p-0 d-flex align-items-center justify-content-center"
                        style={{
                          height: "420px",
                          backgroundColor: "",
                        }}
                      >
                        <img
                          src={
                            selectedProduit.photo_url ||
                            "/static/images/default-product.png"
                          }
                          alt={selectedProduit.nom}
                          className="img-fluid"
                          style={{
                            maxHeight: "100%",
                            maxWidth: "100%",
                            objectFit: "contain",
                          }}
                        />
                      </div>
                      <small className="text-center d-block mt-2">
                        Image du produit
                      </small>
                    </div>

                    {/* Colonne Détails */}
                    <div className="col-md-7">
                      <div className="product-details">
                        {/* Ligne Nom */}
                        <div className="d-flex align-items-center mb-3">
                          <span
                            className="detail-value font-weight-bold text-dark"
                            style={{ fontSize: "1.5rem" }}
                          >
                            {selectedProduit.nom}
                          </span>
                        </div>

                        {/* Ligne Prix */}
                        <div className="d-flex align-items-center mb-3">
                          <span className="detail-label me-2">Prix:</span>
                          <span className="detail-value font-weight-bold">
                            {selectedProduit.prix.toLocaleString()} FCFA
                          </span>
                        </div>
                        {/* Ligne categorie */}
                        <div className="d-flex align-items-center mb-3">
                          <span className="detail-label me-2">Catégorie:</span>
                          <span
                            className="badge"
                            style={{
                              backgroundColor: "#001f3f",
                              color: "white",
                            }}
                          >
                            {categories.find(
                              (cat) => cat.id === selectedProduit.categorie
                            )?.nom || "Non spécifiée"}
                          </span>
                        </div>

                        {/* Bloc Description */}
                        <div className="mb-3">
                          <div className="detail-label mb-2">Description:</div>
                          <textarea
                            className="form-control"
                            value={
                              selectedProduit.description
                                ? selectedProduit.description.replace(
                                  /<[^>]+>/g,
                                  ""
                                ) // supprime les balises HTML
                                : "Aucune description disponible"
                            }
                            rows={4}
                            readOnly
                            style={{ resize: "none" }}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                )}
              </Modal.Body>

              {/* Footer original conservé */}
              <Modal.Footer className="ibox-footer">
                <Button
                  variant="secondary"
                  onClick={() => setSelectedProduit(null)}
                >
                  Fermer
                </Button>
              </Modal.Footer>
            </Modal>

            {/* Modal de confirmation de suppression */}
            <Modal show={showDeleteModal} onHide={handleCloseDeleteModal}>
              <Modal.Header>
                <Modal.Title>Confirmer la Suppression</Modal.Title>
              </Modal.Header>
              <Modal.Body>
                Êtes-vous sûr de vouloir supprimer le produit{" "}
                <strong>{selectedProduit?.nom}</strong> ?
              </Modal.Body>
              <Modal.Footer>
                <Button variant="secondary" onClick={handleCloseDeleteModal}>
                  Annuler
                </Button>
              </Modal.Footer>
            </Modal>

            <style>{`

            /* Styles pour les boutons de catégorie sur mobile */
  @media (max-width: 768px) {
    .categories-container {
      justify-content: center !important;
    }
    
    .category-btn {
      margin: 4px !important;
    }
  }

  /* Définition des colonnes personnalisées */
  .col-lg-2-4 {
    position: relative;
    width: 100%;
    padding-right: 8px;
    padding-left: 8px;
    flex: 0 0 20%;
    max-width: 20%;
  }

  /* Pour les tablettes */
  @media (max-width: 992px) {
    .col-lg-2-4 {
      flex: 0 0 33.3333%;
      max-width: 33.3333%;
    }
  }

  /* Pour les mobiles - 2 par ligne */
  @media (max-width: 768px) {
    .col-6 {
      flex: 0 0 50%;
      max-width: 50%;
    }
    
    .product-box {
      margin-bottom: 0;
    }
    
    .ibox-content {
      padding: 10px !important;
    }
    
    .product-imitation {
      height: 120px !important;
    }
    
    .product-name {
      font-size: 0.9rem !important;
    }
  }

  /* Pour les très petits écrans - conserve 2 par ligne */
  @media (max-width: 576px) {
    .col-6 {
      flex: 0 0 50%;
      max-width: 50%;
    }
  }
`}</style>
          </div>
        </div>
      </div>



    </div>
  );
};

export default Accueil;
